import { i18nMark } from 'lingui-react';

export const noResultsTitlesForMode = {
  default: i18nMark('No Matches Found'),
  highlightedOnly: i18nMark('No cases to show at the moment'),
};

export const noResultsMessagesForMode = {
  default: i18nMark(
    'Try removing or editing some of your filters, or search by a different field.',
  ),
};



// WEBPACK FOOTER //
// ./src/compositions/CasesSearch/Results/constants.js